var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00013 12.8305L11.8043 15.1313C12.501 15.553 13.3535 14.9296 13.1701 14.1413L12.1618 9.81462L15.526 6.89962C16.1401 6.36796 15.8101 5.35962 15.0035 5.29546L10.576 4.91962L8.84346 0.831289C8.53179 0.0887891 7.46846 0.0887891 7.15679 0.831289L5.42429 4.91046L0.996794 5.28629C0.190128 5.35046 -0.139872 6.35879 0.474294 6.89046L3.83846 9.80546L2.83013 14.1321C2.64679 14.9205 3.49929 15.5438 4.19596 15.1221L8.00013 12.8305Z",
    fill: "#FBBA12"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/starYellow.ab3cfc9dcfa55f83f3d4df88b0bb556c.svg";
export { ForwardRef as ReactComponent };